/**
 * Hide the native Shopify product grid section when Boost injects its own.
 * Runs once Boost's container element appears in the DOM.
 */
(function () {
  function hideNativeGrid() {
    var nativeGrid = document.getElementById('ProductGridContainer');
    var nativeFilters = document.getElementById('main-collection-filters');
    if (nativeGrid) nativeGrid.style.display = 'none';
    if (nativeFilters) nativeFilters.style.display = 'none';
  }

  function boostIsPresent() {
    return !!document.querySelector('.boost-sd__filter-product-list');
  }

  if (boostIsPresent()) {
    hideNativeGrid();
    return;
  }

  var observer = new MutationObserver(function () {
    if (boostIsPresent()) {
      hideNativeGrid();
      observer.disconnect();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (boostIsPresent()) {
      hideNativeGrid();
    } else {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });
})();

/**
 * Boost PLP Pagination Enhancement
 *
 * Fixes:
 * 1. Makes << and >> buttons functional (navigate to first/last page)
 * 2. Ensures PREV and NEXT buttons are always visible on all pages
 * 3. [MOBILE ≤750px] Smart pagination: shows current context + last page number
 *    Pattern: 1 2 3 ... [last]  /  [first] ... X-1 X X+1 ... [last]  /  [first] ... X-2 X-1 X
 */
(function () {
  'use strict';

  var SELECTORS = {
    pagination: '.boost-sd__pagination',
    pageNumber: '.boost-sd__pagination-number:not(.boost-sd__pagination-number--disabled)',
    allPageNumbers: '.boost-sd__pagination-number',
    activeNumber: '.boost-sd__pagination-number--active',
    prevButton: '.boost-sd__pagination-button--prev',
    nextButton: '.boost-sd__pagination-button--next',
    ellipsis: '.boost-sd__pagination-ellipsis'
  };

  var TIMINGS = {
    initial: 300,
    retry: [600, 1000],
    observer: 200,
    observerRetry: 500
  };

  var MOBILE_BREAKPOINT = 750;

  var SVG_ICONS = {
    doubleLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M10.7194 11.4694L18.2194 3.96944C18.3602 3.82871 18.551 3.74965 18.7501 3.74965C18.9491 3.74965 19.14 3.82871 19.2807 3.96944C19.4214 4.11018 19.5005 4.30105 19.5005 4.50007C19.5005 4.69909 19.4214 4.88997 19.2807 5.0307L12.3104 12.0001L19.2807 18.9694C19.4214 19.1102 19.5005 19.301 19.5005 19.5001C19.5005 19.6991 19.4214 19.89 19.2807 20.0307C19.14 20.1714 18.9491 20.2505 18.7501 20.2505C18.551 20.2505 18.3602 20.1714 18.2194 20.0307L10.7194 12.5307C10.6497 12.461 10.5944 12.3783 10.5567 12.2873C10.5189 12.1962 10.4995 12.0986 10.4995 12.0001C10.4995 11.9015 10.5189 11.8039 10.5567 11.7129C10.5944 11.6218 10.6497 11.5391 10.7194 11.4694ZM3.21944 12.5307L10.7194 20.0307C10.8602 20.1714 11.051 20.2505 11.2501 20.2505C11.4491 20.2505 11.64 20.1714 11.7807 20.0307C11.9214 19.89 12.0005 19.6991 12.0005 19.5001C12.0005 19.301 11.9214 19.1102 11.7807 18.9694L4.81038 12.0001L11.7807 5.0307C11.9214 4.88997 12.0005 4.69907 12.0005 4.50007C12.0005 4.30105 11.9214 4.11018 11.7807 3.96944C11.64 3.82871 11.4491 3.74965 11.2501 3.74965C11.051 3.74965 10.8602 3.82871 10.7194 3.96944L3.21944 11.4694C3.14971 11.5391 3.09439 11.6218 3.05665 11.7129C3.01891 11.8039 2.99948 11.9015 2.99948 12.0001C2.99948 12.0986 3.01891 12.1962 3.05665 12.2873C3.09439 12.3783 3.14971 12.461 3.21944 12.5307Z" fill="black"/></svg>',
    doubleRight: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M13.2806 12.5307L5.78055 20.0307C5.63982 20.1714 5.44895 20.2505 5.24993 20.2505C5.05091 20.2505 4.86003 20.1714 4.7193 20.0307C4.57857 19.8899 4.49951 19.6991 4.49951 19.5001C4.49951 19.301 4.57857 19.1102 4.7193 18.9694L11.6896 12.0001L4.7193 5.03068C4.57857 4.88995 4.49951 4.69907 4.49951 4.50005C4.49951 4.30103 4.57857 4.11016 4.7193 3.96943C4.86003 3.8287 5.05091 3.74963 5.24993 3.74963C5.44895 3.74963 5.63982 3.8287 5.78055 3.96943L13.2806 11.4694C13.3503 11.5391 13.4056 11.6218 13.4433 11.7128C13.4811 11.8039 13.5005 11.9015 13.5005 12.0001C13.5005 12.0986 13.4811 12.1962 13.4433 12.2873C13.4056 12.3783 13.3503 12.461 13.2806 12.5307ZM20.7806 11.4694L13.2806 3.96943C13.1398 3.8287 12.949 3.74963 12.7499 3.74963C12.5509 3.74963 12.36 3.8287 12.2193 3.96943C12.0786 4.11016 11.9995 4.30103 11.9995 4.50005C11.9995 4.69907 12.0786 4.88995 12.2193 5.03068L19.1896 12.0001L12.2193 18.9694C12.0786 19.1102 11.9995 19.301 11.9995 19.5001C11.9995 19.6991 12.0786 19.8899 12.2193 20.0307C12.36 20.1714 12.5509 20.2505 12.7499 20.2505C12.949 20.2505 13.1398 20.1714 13.2806 20.0307L20.7806 12.5307C20.8503 12.461 20.9056 12.3783 20.9433 12.2873C20.9811 12.1962 21.0005 12.0986 21.0005 11.7128C20.9056 11.6218 20.8503 11.5391 20.7806 11.4694Z" fill="black"/></svg>'
  };

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function createNavigationButton(type, targetPage) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'boost-sd__pagination-' + type + '-page';
    button.setAttribute('aria-label', 'Go to ' + type + ' page');
    button.innerHTML = type === 'first' ? SVG_ICONS.doubleLeft : SVG_ICONS.doubleRight;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (!button.disabled && targetPage) {
        targetPage.click();
      }
    });

    return button;
  }

  function getCurrentPageNumber(pagination) {
    var activeNum = pagination.querySelector(SELECTORS.activeNumber);
    return activeNum ? parseInt(activeNum.textContent, 10) : 1;
  }

  function forceButtonVisibility(button) {
    if (button) {
      button.style.setProperty('display', 'inline-flex', 'important');
      button.style.setProperty('visibility', 'visible', 'important');
    }
  }

  function ensurePrevNextVisible() {
    document.querySelectorAll(SELECTORS.pagination).forEach(function (pagination) {
      forceButtonVisibility(pagination.querySelector(SELECTORS.prevButton));
      forceButtonVisibility(pagination.querySelector(SELECTORS.nextButton));
    });
  }

  // ─── Mobile Smart Pagination ─────────────────────────────────────────────────
  //
  // Reads the real page buttons that Boost already rendered, then hides/shows
  // them + Boost's own ellipsis elements. Never injects new DOM nodes.
  //
  // Patterns (3 visible numbers around current):
  //   Near start  : 1  2  3  …  [last]
  //   Middle      : 1  …  prev  cur  next  …  [last]
  //   Near end    : 1  …  [last-2]  [last-1]  [last]

  /**
   * Build the set of page numbers that should be VISIBLE on mobile.
   * Always shows: first, last, and up to 3 around current.
   */
  function getVisiblePages(current, total) {
    var visible = new Set();
    visible.add(1);
    visible.add(total);

    // window of 3 around current (prev, cur, next) clamped to [1, total]
    for (var p = Math.max(1, current - 1); p <= Math.min(total, current + 1); p++) {
      visible.add(p);
    }

    return visible;
  }

  function applyMobilePagination(pagination) {
    if (!isMobile()) return;

    // Collect all children in DOM order so we can reason about neighbours
    var children = Array.from(pagination.children);

    // Build a map: pageNum → button element (numeric buttons only)
    var pageMap = {};
    var totalPages = 0;

    children.forEach(function (el) {
      if (el.classList.contains('boost-sd__pagination-number')) {
        var n = parseInt(el.textContent, 10);
        if (!isNaN(n)) {
          pageMap[n] = el;
          if (n > totalPages) totalPages = n;
        }
      }
    });

    if (totalPages < 2) return; // nothing to collapse

    var current = getCurrentPageNumber(pagination);
    var visibleSet = getVisiblePages(current, totalPages);

    // ── 1. Show/hide numeric page buttons ──────────────────────────────────
    Object.keys(pageMap).forEach(function (key) {
      var n = parseInt(key, 10);
      if (visibleSet.has(n)) {
        pageMap[n].style.removeProperty('display');
      } else {
        pageMap[n].style.setProperty('display', 'none', 'important');
      }
    });

    // ── 2. Handle Boost's existing ellipsis elements ────────────────────────
    // Strategy: hide ALL of Boost's ellipses first, then show each one only
    // if there is actually a gap (hidden number buttons) on BOTH sides of it
    // in DOM order.
    var boostEllipses = pagination.querySelectorAll(SELECTORS.ellipsis);
    boostEllipses.forEach(function (el) {
      // Find the nearest visible numeric button before and after this ellipsis
      var prev = el.previousElementSibling;
      var next = el.nextElementSibling;

      var prevNum = null;
      var nextNum = null;

      // Walk backwards to find previous numeric page button that is visible
      var cursor = el.previousElementSibling;
      while (cursor) {
        var pn = parseInt(cursor.textContent, 10);
        if (!isNaN(pn) && cursor.classList.contains('boost-sd__pagination-number')) {
          prevNum = pn;
          break;
        }
        cursor = cursor.previousElementSibling;
      }

      // Walk forward to find next numeric page button that is visible
      cursor = el.nextElementSibling;
      while (cursor) {
        var nn = parseInt(cursor.textContent, 10);
        if (!isNaN(nn) && cursor.classList.contains('boost-sd__pagination-number')) {
          nextNum = nn;
          break;
        }
        cursor = cursor.nextElementSibling;
      }

      // Show ellipsis only if there is a real gap between prevNum and nextNum
      // i.e. at least one hidden number sits between them
      var hasGap = (prevNum !== null && nextNum !== null && nextNum - prevNum > 1);
      if (hasGap) {
        el.style.removeProperty('display');
      } else {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function resetMobilePagination(pagination) {
    // Show all real buttons and ellipses again (desktop resize)
    pagination.querySelectorAll(SELECTORS.allPageNumbers).forEach(function (btn) {
      btn.style.removeProperty('display');
    });
    pagination.querySelectorAll(SELECTORS.ellipsis).forEach(function (el) {
      el.style.removeProperty('display');
    });
  }

  function applyMobileToAll() {
    document.querySelectorAll(SELECTORS.pagination).forEach(function (pagination) {
      if (isMobile()) {
        applyMobilePagination(pagination);
      } else {
        resetMobilePagination(pagination);
      }
    });
  }

  // ─── Core Enhancement (first/last buttons + prev/next visibility) ────────────

  function enhancePagination() {
    var containers = document.querySelectorAll(SELECTORS.pagination);
    if (!containers.length) return;

    containers.forEach(function (pagination) {
      if (pagination.dataset.boostPaginationEnhanced === 'true') {
        // Re-apply mobile on re-render (pages change)
        applyMobilePagination(pagination);
        return;
      }
      pagination.dataset.boostPaginationEnhanced = 'true';

      var pageButtons = pagination.querySelectorAll(SELECTORS.pageNumber);
      if (!pageButtons.length) return;

      var firstPage = pageButtons[0];
      var lastPage = pageButtons[pageButtons.length - 1];
      var currentPage = getCurrentPageNumber(pagination);
      var lastPageNum = lastPage ? parseInt(lastPage.textContent, 10) : 1;

      var firstBtn = createNavigationButton('first', firstPage);
      var lastBtn = createNavigationButton('last', lastPage);

      if (currentPage <= 1) firstBtn.disabled = true;
      if (currentPage >= lastPageNum) lastBtn.disabled = true;

      forceButtonVisibility(pagination.querySelector(SELECTORS.prevButton));
      forceButtonVisibility(pagination.querySelector(SELECTORS.nextButton));

      pagination.insertBefore(firstBtn, pagination.firstChild);
      pagination.appendChild(lastBtn);

      // Apply mobile truncation
      applyMobilePagination(pagination);
    });
  }

  // ─── Resize handling ─────────────────────────────────────────────────────────

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyMobileToAll, 150);
  });

  // ─── Init ────────────────────────────────────────────────────────────────────

  function initialize() {
    setTimeout(function () {
      enhancePagination();
      ensurePrevNextVisible();
    }, TIMINGS.initial);

    TIMINGS.retry.forEach(function (delay) {
      setTimeout(ensurePrevNextVisible, delay);
    });
  }

  function setupEventListeners() {
    document.addEventListener('DOMContentLoaded', initialize);
    document.addEventListener('boostPFSAfterRender', function () {
      // Reset enhanced flags so re-render gets fresh treatment
      document.querySelectorAll(SELECTORS.pagination).forEach(function (p) {
        delete p.dataset.boostPaginationEnhanced;
      });
      initialize();
    });
    document.addEventListener('boostPFSFilterRendered', function () {
      document.querySelectorAll(SELECTORS.pagination).forEach(function (p) {
        delete p.dataset.boostPaginationEnhanced;
      });
      initialize();
    });
  }

  function setupMutationObserver() {
    var observer = new MutationObserver(function (mutations) {
      var paginationFound = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            (node.classList && node.classList.contains('boost-sd__pagination')) ||
            (node.querySelector && node.querySelector(SELECTORS.pagination))
          );
        });
      });

      if (paginationFound) {
        setTimeout(function () {
          enhancePagination();
          ensurePrevNextVisible();
        }, TIMINGS.observer);
        setTimeout(ensurePrevNextVisible, TIMINGS.observerRetry);
      }
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        observer.observe(document.body, { childList: true, subtree: true });
      });
    }
  }

  setupEventListeners();
  setupMutationObserver();
})();
/**
 * Boost removes the native collection banner (and its subcategory carousel)
 * when it renders its own listing. Keep a reference to the section and put it
 * back above Boost's container whenever it gets detached.
 */
(function () {
  var bannerSection = null;
  var restores = 0;
  var MAX_RESTORES = 20;

  function findBanner() {
    return document.querySelector('#MainContent [id^="shopify-section-"][id$="__banner"]');
  }

  function restoreBanner() {
    if (!bannerSection || bannerSection.isConnected || restores >= MAX_RESTORES) return;
    var boostList = document.querySelector('.boost-sd__filter-product-list');
    if (!boostList || !boostList.parentNode) return;

    boostList.parentNode.insertBefore(bannerSection, boostList);
    restores++;
    // Splide measures its track, so let it re-measure now that the slider is visible again
    window.dispatchEvent(new Event('resize'));
  }

  function init() {
    bannerSection = findBanner();
    if (!bannerSection) return;

    restoreBanner();
    new MutationObserver(restoreBanner).observe(
      document.getElementById('MainContent') || document.body,
      { childList: true, subtree: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Figma shows the selected filter chips above the product grid, but Boost renders them inside the
 * left filter column. Keep Boost's own node where it is (it re-renders it) and mirror it above the grid.
 * Boost reads the "metadata" attribute of the clicked element, so the clone keeps working.
 */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1050px)');
  var MIRROR_CLASS = 'boost-sd__refine-mirror';
  var queued = false;

  function sync() {
    queued = false;
    var right = document.querySelector('.boost-sd-right');
    var source = document.querySelector('.boost-sd-left .boost-sd__refine-by-vertical-refine-by');
    var mirror = right && right.querySelector(':scope > .' + MIRROR_CLASS);

    if (!right || !source || !DESKTOP.matches) {
      if (mirror) mirror.remove();
      return;
    }
    if (!mirror) {
      mirror = document.createElement('div');
      mirror.className = MIRROR_CLASS;
      right.insertBefore(mirror, right.querySelector(':scope > .boost-sd__product-list'));
    }

    var html = source.outerHTML.replace(/\sid="[^"]*"/g, '');
    if (mirror.getAttribute('data-source') !== html) {
      mirror.innerHTML = html;
      mirror.setAttribute('data-source', html);
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  DESKTOP.addEventListener('change', schedule);
  schedule();
})();
